import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AppShellContents } from '@/components/layout/AppShell';
import { ContactSupportCard } from '@/components/support/ContactSupportCard';
import { TopBar } from '@/components/topBar/TopBar';
import { useTeamNavigationClassic } from '@/hooks/navigation/useTeamNavigation';

const NotFoundCard = () => {
  const { t } = useTranslation('general', { keyPrefix: 'notFound' });
  const teamDashboardRoute = useTeamNavigationClassic();

  return (
    <ContactSupportCard
      isFullscreen
      buttonProps={{
        as: Link,
        children: t('buttonLink'),
        to: `${teamDashboardRoute}dashboard`,
        size: 'small',
        variant: 'secondary',
      }}
      title={t('title')}
      description={t('descriptionText')}
      linkText={t('descriptionContactText')}
    />
  );
};

export const NotFound = () => (
  <AppShellContents topBar={<TopBar />}>
    <NotFoundCard />
  </AppShellContents>
);
